/* Default passive event listeners for better scroll performance on mobile.
 * Applies to touchstart, touchmove, and wheel when not explicitly set.
 * Safe: respects existing options and capture booleans.
 */
(function(){
  if (!('addEventListener' in EventTarget.prototype)) return;
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, 'passive', { get: function(){ supportsPassive = true; } });
    window.addEventListener('test-passive', function(){}, opts);
    window.removeEventListener('test-passive', function(){}, opts);
  } catch(e) {}
  if (!supportsPassive) return;

  var passiveTypes = ['touchstart','touchmove','wheel'];
  var orig = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options){
    try {
      if (passiveTypes.indexOf(type) !== -1) {
        if (options === undefined) {
          options = { passive: true };
        } else if (typeof options === 'boolean') {
          options = { capture: options, passive: true };
        } else if (options && typeof options === 'object' && options.passive === undefined) {
          options = Object.assign({ passive: true }, options);
        }
      }
    } catch(e) {}
    return orig.call(this, type, listener, options);
  };
})();
